/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      code: "code"
    }, _provideComponents(), props.components);
    return _jsxs(_components.p, {
      children: ["Этот способ концептуально не отличается от начального, мы так же имеем методы, которые должны быть реализованы, но не должны выполнять каких-то действий: ", _jsx(_components.code, {
        children: "delete"
      }), ", ", _jsx(_components.code, {
        children: "publish"
      }), " и т.д"]
    });
  }
}
export default MDXContent;
